module.exports = __webpack_public_path__ + "static/img/yiqi1.1209c8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/设备及原料/仪器设备/氨解仪/yiqi1.png
// module id = eIBG
// module chunks = 1